/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientPackageItems = sqliteTable('patient_package_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_package_id: text('patient_package_id'),
  child_type: text('child_type'),
  child_inventory_item_id: text('child_inventory_item_id'),
  child_appointment_service_id: text('child_appointment_service_id'),
  item_name_snapshot: text('item_name_snapshot'),
  item_code_snapshot: text('item_code_snapshot'),
  item_type_snapshot: text('item_type_snapshot'),
  total_quantity: real('total_quantity'),
  redeemed_quantity: real('redeemed_quantity'),
  remaining_quantity: real('remaining_quantity'),
  unit_price_snapshot: real('unit_price_snapshot'),
  sort_order: integer('sort_order'),
  status: text('status'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
